import { Socket } from "socket.io-client";
import { ApiGame } from "../types/apigame";
import { GetGamesForUserParams, GetGamesForUserType } from "../models/socket/game";
import { ClientRequests } from "../enum/socket";
import { COMPLETED_GAMES_LIST_DEFAULT_PAGE_SIZE } from "../../components/game/gameslist/completedgameslist";

class ActiveGamesClient {
    constructor(
        protected socket: Socket,
        protected userId: number,
    ) {
    }

    public async getActiveGames(): Promise<ApiGame[] | null> {
        return this.getGameList(
            {
                searchType: GetGamesForUserType.Active
            },
        );
    }

    public async getCompletedGames(): Promise<ApiGame[] | null> {
        return this.getGameList({
            searchType: GetGamesForUserType.Completed,
            take: COMPLETED_GAMES_LIST_DEFAULT_PAGE_SIZE,
        });
    }

    public async getOpenGames(): Promise<ApiGame[] | null> {
        return this.getGameList(
            {
                searchType: GetGamesForUserType.Open,
            },
        );
    }

    public async getLiveGames(): Promise<ApiGame[] | null> {
        return this.getGameList(
            {
                searchType: GetGamesForUserType.Live,
            },
        );
    }

    public async getGame(
        gameId: number,
        searchType?: GetGamesForUserType,
    ): Promise<ApiGame | null> {
        if (!this.socket || !this.userId) {
            return null;
        }

        const params: GetGamesForUserParams = {
            gameIds: [gameId],
            searchType,
        };

        let getGamesResult: ApiGame[];

        try {
            getGamesResult = await this.socket.emitWithAck(
                ClientRequests.GetGames,
                params,
            );
        } catch (err) {
            return null;
        }

        if (getGamesResult?.length > 0) {
            return getGamesResult[0];
        } else {
            return null;
        }
    }

    private async getGameList(params: GetGamesForUserParams): Promise<ApiGame[] | null> {
        if (!this.socket || !this.userId) {
            return null;
        }

        let getGamesResult: ApiGame[];

        try {
            getGamesResult = await this.socket.emitWithAck(
                ClientRequests.GetGames,
                params,
            );
        } catch (err) {
            return null;
        }

        return getGamesResult;
    }
}

export default ActiveGamesClient;
